import React from "react";
import CustomInput from "../components/formik/CustomInput";
import CustomSelect from "../components/formik/CustomSelect";
import { useOrderVialContext } from "../context/OrderVialContext";
import { utils, writeFile } from "xlsx-js-style";
import {
  ServiceBackground,
  ServiceConact,
} from "../components/reports/ServiceColumn";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import {
  getCurrentFortnightName,
  getOrderType,
  getReason,
} from "../models/ReportOperatorSalary";

const OrderVialForm = ({
  value,
  onChange,
  onSearch,
  onKeyPress,
  formik,
  serviceTypes,
  records,
}) => {
  const { orderStatuses, orderStatesFilter } = useOrderVialContext();

  const statusOptions = [
    { value: "all", label: "Todas" },
    ...orderStatuses
      .filter((status) => status !== "Cancelado")
      .map((status) => ({ value: status, label: status })),
  ];

  const orderStatesOptions = [
  { value: "all", label: "Todas" },
    ...orderStatesFilter,
  ];

  const exportToExcel = () => {
    const baseUrl = window.location.origin;
    const workbook = utils.book_new();
    const sheetName = "Órdenes";
    const sheetData = [
      [
        "Folio",
        "Descripción del servicio",
        "Tipo de Servicio",
        "Fecha",
        "Total (Sin IVA)",
        "Total (Con IVA)",
        "Razón",
        "Total Facturas",
        "Total Pagos",
      ],
    ];

    let totalSubtotal = 0;
    let totalInvoices = 0;
    let totalPayments = 0;
    let totalOrden = 0;

    const ordersArray = Array.isArray(records) ? records : [];

    ordersArray.forEach((Order) => {
      const bg = ServiceBackground({ row: Order });
      const orderType =
        Order.tipoServicio != null ? Order.tipoServicio : getOrderType(Order);
      const subtotal = Number(Order.subtotal) || 0;
      const invoices = Number(Order.totalFacturas) || 0;
      const payments = Number(Order.totalPagos) || 0;
      const reason = Order.razon?.trim() ? Order.razon : getReason(Order);
      const totalConIVA = Number(Order.totalConIVA) || 0;

      sheetData.push([
        {
          t: "s",
          v: Order.folio,
          //v: Order.folio.toString().padStart(5, "0"),
          l: {
            Target:
              Order.tipo === "Varo Express"
                ? `${baseUrl}/orders-vial/editOrder/${Order.order_id}`
                : `${baseUrl}/orders/edit/${Order.order_id}`,
          },
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: orderType,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: ServiceConact({ row: Order }),
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "s",
          v: format(new Date(Order.fecha_hora_reporte), "dd/MMM/yyyy", {
            locale: es,
          }),
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: subtotal,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: totalConIVA,
          s: { fill: { fgColor: { rgb: bg } } },
        },

        {
          t: "s",
          v: reason,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: invoices,
          s: { fill: { fgColor: { rgb: bg } } },
        },
        {
          t: "n",
          v: payments,
          s: { fill: { fgColor: { rgb: bg } } },
        },
      ]);

      totalSubtotal += subtotal;
      totalInvoices += invoices;
      totalPayments += payments;
      totalOrden += totalConIVA;
    });

    // Fila vacía
    sheetData.push([{ t: "s", v: "" }]);

    // Fila de totales
    sheetData.push([
      { t: "s", v: "Total" },
      { t: "s", v: "" },
      { t: "s", v: "" },
      { t: "s", v: "" },
      { t: "n", v: totalSubtotal },
      { t: "n", v: totalOrden },
      { t: "s", v: "" },
      { t: "n", v: totalInvoices },
      { t: "n", v: totalPayments },
    ]);

    const worksheet = utils.aoa_to_sheet(sheetData);
    worksheet["!cols"] = [
      { wch: 20 }, // Folio
      { wch: 35 }, // Descripción
      { wch: 20 }, // Tipo servicio
      { wch: 30 }, // Fecha
      { wch: 20 }, // Total sin IVA
      { wch: 20 }, // Total con IVA
      { wch: 35 }, // Razón
      { wch: 20 }, // Total Facturas
      { wch: 20 }, // Total Pagos
    ];

    utils.book_append_sheet(workbook, worksheet, sheetName);


    // Formatear fechas o usar fecha actual si no existen
    const today = format(new Date(), "yyyy-MM-dd");
    const fileName = `VaroExpress_${today}.xlsx`;

    // Guardar archivo
    writeFile(workbook, fileName);

    //writeFile(workbook, getCurrentFortnightName() + ".xlsx");
  };

  //console.log(serviceTypes);

  return (
    <div className="row mb-3 align-items-end">
      {/* Filtros sin botón */}
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-2">
            <CustomInput
              label="Fecha inicio"
              field="start"
              type="date"
              formik={formik}
              className={`form-control ${
                formik.touched.start && formik.errors.start ? "is-invalid" : ""
              }`}
              onChange={(e) => {
                formik.setFieldTouched("start", true);
                formik.setFieldValue("start", value);
              }}
            />
          </div>
          <div className="col-md-2">
            <CustomInput
              label="Fecha fin"
              field="end"
              type="date"
              formik={formik}
              className={`form-control ${
                formik.touched.end && formik.errors.end ? "is-invalid" : ""
              }`}
              onChange={(e) => {
                formik.setFieldTouched("end", true);
                formik.setFieldValue("end", value);
              }}
            />
          </div>
          <div className="col-md-2">
            <CustomSelect
              label="Estatus"
              field="status"
              formik={formik}
              options={statusOptions}
              required
              className="form-control-sm"
              onChange={(e) => {
                formik.setFieldTouched("status", true);
                formik.setFieldValue("status", value);
              }}
            />
          </div>
          <div className="col-md-2">
            <CustomSelect
              label="Estatus orden"
              field="statusOrden"
              formik={formik}
              options={orderStatesOptions}
              required
              className="form-control-sm"
              onChange={(e) => {
                formik.setFieldTouched("statusOrden", true);
                formik.setFieldValue("statusOrden", value);
              }}
            />
          </div>
          <div className="col-md-2">
            <CustomSelect
              label="Tipo de servicio"
              field="typeServiceId"
              formik={formik}
              options={[
                { value: "all", label: "Todos" },
                ...(Array.isArray(serviceTypes)
                  ? serviceTypes.map((service) => ({
                      value: service.id,
                      label: service.type_service_name,
                    }))
                  : []),
              ]}
              required={false}
              className="form-control-sm"
              onChange={() => {
                // Obtener el valor actual desde formik
                const selectedValue = formik.values.typeServiceId;

                console.log("Cambio en typeServiceId:", selectedValue);

                const selectedOption = serviceTypes.find(
                  (service) => String(service.id) === String(selectedValue)
                );

                console.log("Opción completa:", selectedOption);
              }}
            />
          </div>
          <div className="col-md-2 text-end pt-3">
            <button className="btn btn-success btn-lg" onClick={exportToExcel}>
              <i className="fa-solid fa-file-excel" /> &nbsp;Descargar
            </button>
          </div>
        </div>
      </div>
      {/* Buscador */}
      {/* <div className="col-md-3 text-end">
        <div className="input-group input-group-sm">
          <input
            type="text"
            className="form-control"
            style={{
              height: "36.75px",
              margin: "0 0 5px",
              padding: "7px 12px",
            }}
            placeholder="Buscar..."
            value={value}
            onChange={onChange}
            onKeyPress={onKeyPress}
          />
          <button
            className="btn btn-info"
            type="button"
            style={{
              height: "36.75px",
              margin: "0 0 5px",
              padding: "7px 12px",
            }}
            onClick={onSearch}
          >
            <i className="fa fa-search"></i>
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default OrderVialForm;
